import React from "react";
import '../../styles/components/lesson/speed-selector.scss';
import {increaseSpeed, decreaseSpeed, changeSpeed} from "../../redux/lesson/lessonActions";
import ISelectOption from "../../models/view/common/ISelectOption";
import ControlBarDropDown from "./ControlBarDropDown";
import ControlBarDropDownMenuItem from "./ControlBarDropDownMenuItem";
import DecrementIncrementButtons from "../common/DecrementIncrementButtons";
import {SpeedSelectorIcon} from "../../modules/lesson/speed-selector-icon/SpeedSelectorIcon";
import {useAppSelector} from "../../redux/hooks";
import {lessonPlayerStore} from "../../redux/lesson/LessonPlayerStore";

interface ITempoSelectorProps {
}

export function TempoSelector({}: ITempoSelectorProps) {
  const segment = useAppSelector(lessonPlayerStore.getSegment);
  const isTempoDropdownSelectorOpen = useAppSelector(lessonPlayerStore.getIsTempoSelectorDropdownOpen);
  const currentlySelectedSpeed = useAppSelector(lessonPlayerStore.getSpeed);
  const speedOptions = segment?.speedOptions ?? [];
  const playbackControlState = useAppSelector(lessonPlayerStore.getPlaybackControlState);
  const controlBarTogglesEnabledState = useAppSelector(lessonPlayerStore.getControlBarTogglesEnabledState);
  const tempo = playbackControlState.tempo;
  const isDisabled = !controlBarTogglesEnabledState;
  const tempoOptionEls = createOptions(speedOptions, changeSpeed, currentlySelectedSpeed);
  const roundedTempo = `${Math.round(tempo)}`;
  const isSpeedModifierMenuOptionSelectedValue = isSpeedModifierMenuItemSelected(currentlySelectedSpeed, speedOptions);
  const isIncrementSpeedEnabled = currentlySelectedSpeed < 1.25;
  const isDecrementSpeedEnabled = currentlySelectedSpeed > .25;

  return (
    <ControlBarDropDown
      additionalCssClassName={'speed-selector'}
      tooltip={"Tempo"}
      ariaLabel={"Tempo"}
      isDropdownMenuOpen={isTempoDropdownSelectorOpen}
      changeDropdownMenuOpen={(isOpen: boolean) => { lessonPlayerStore.setIsTempoSelectorDropdownOpen(isOpen); }}
      iconElement={<SpeedSelectorIcon />} disabled={isDisabled}>
      {tempoOptionEls}
      <ControlBarDropDownMenuItem isSelected={isSpeedModifierMenuOptionSelectedValue}>
        <div className="speed-modifier-buttons">
          <DecrementIncrementButtons
            onIncrementClick={increaseSpeed}
            onDecrementClick={decreaseSpeed}
            label={roundedTempo}
            subLabel={`Beats Per Minute`}
            decrementButtonEnabled={isDecrementSpeedEnabled}
            incrementButtonEnabled={isIncrementSpeedEnabled}
          />
        </div>
      </ControlBarDropDownMenuItem>
    </ControlBarDropDown>
  );
}

function isSpeedModifierMenuItemSelected(currentSpeed: number, speedOptions: ISelectOption<number>[]){
  return !speedOptions.find(o => o.value === currentSpeed);
}
function createOptions(speedOptions: ISelectOption<number>[], changeSpeed:(speed: number)=> void, currentlySelectedSpeed: number){
  return speedOptions.map(so => createSpeedOption(so, changeSpeed, currentlySelectedSpeed));
}

function createSpeedOption(speedOption: ISelectOption<number>, changeSpeed:(speed: number)=> void, currentlySelectedSpeed: number){
  const isSelected = speedOption.value === currentlySelectedSpeed;
  return <ControlBarDropDownMenuItem key={`speed_${speedOption.value}`} isSelected={isSelected} onClick={()=> {changeSpeed(speedOption.value); }}>{speedOption.label}</ControlBarDropDownMenuItem>;
}
